import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const navLinks = [
    { to: '/', label: '首页' },
    { to: '/category/rexue', label: '分类浏览' },
    { to: '/about', label: '关于我们' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/80'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-8">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link
            to="/"
            className="flex items-center gap-2 group whitespace-nowrap"
          >
            <span className="text-2xl md:text-3xl font-heading font-bold text-primary-600 group-hover:text-primary-700 transition-colors">
              jm漫画
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  location.pathname === link.to
                    ? 'text-primary-600'
                    : scrolled
                    ? 'text-foreground-700 hover:text-primary-600'
                    : 'text-foreground-50 hover:text-accent-300'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <a
              href="#download"
              className={`inline-flex items-center gap-1.5 px-5 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                scrolled
                  ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
                  : 'bg-background-50/20 text-background-50 border border-background-50/30 hover:bg-background-50/30 backdrop-blur-sm'
              }`}
            >
              <i className="ri-download-line"></i>
              APP下载
            </a>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${scrolled ? 'text-foreground-800' : 'text-background-50'} ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/60 shadow-lg">
          <div className="px-4 py-4 flex flex-col gap-3">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`text-sm font-medium py-2 px-3 rounded-lg transition-colors whitespace-nowrap cursor-pointer ${
                  location.pathname === link.to
                    ? 'text-primary-600 bg-primary-50'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <a
              href="#download"
              className="inline-flex items-center justify-center gap-1.5 px-5 py-2.5 rounded-full text-sm font-medium bg-primary-500 text-background-50 hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-download-line"></i>
              APP下载
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}